//Importing UI Components
import { useState } from 'react'
import { Form } from '../form/FormComponents'
import { memo } from 'react'

//Setting up subcomponents
import Display from '../display/Display'
import ModalForm from './ModalForm'
import resolveModalForm from '../../utils/model/resolveModalForm'
import { resolveVisibility } from '../../../../common/model/condition/evaluate'

const ModalSection = memo(({ section, expanded, toggleExpanded, validated, dispatch, entity, useStore, options }) => {
    const [showModal, setShowModal] = useState(false)

    if (!section) return null

    //Ignore items that do not match the condition
    if (resolveVisibility(section.meta, { values: {}, context: { mode: options?.mode } }) !== 'show') return <></>

    const testId = `${section.id}`

    //Determines if it needs to load ModalGroups or if it is embedded
    const modalForm = resolveModalForm(section.groups[0])

    const runAction = () => {
        setShowModal(true)
    }

    return (

        <Form.Section name='FormSection' width={section.meta.width}>
            <Display
                type='root' section={section} clickAction={runAction} showAction={true} >
            </Display>
            {showModal && <ModalForm
                name='ModalForm'
                mode=''
                isVisible={showModal}
                setIsVisible={setShowModal}
                modalTitle={section.groups[0].control.label}
                id={modalForm.id}
                groups={modalForm.elements}
                buttons={modalForm.buttons}
                submit={modalForm.submit}
                lineId={0}
                validated={validated}
                section={section}
                entity={entity}
                useStore={useStore}
                testId={testId}
            >
            </ModalForm>}
        </Form.Section>

    )

})


export default ModalSection